import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  selectedItems: [],
};

const guestRequestSlice = createSlice({
  name: 'guestRequest',
  initialState,
  reducers: {
    updateSelectedRequestItems: (state, action) => {
      const index = state.selectedItems.findIndex(
        item => item.serviceRequestId === action.payload.serviceRequestId
      );
      
      if (index === -1) {
        state.selectedItems.push(action.payload);
      } else {
        state.selectedItems.splice(index, 1);
      }
    },
    clearSelectedItems: state => {
      state.selectedItems = [];
    },
  },
});

export const {
  updateSelectedRequestItems,
  clearSelectedItems,
} = guestRequestSlice.actions;

export default guestRequestSlice.reducer;
